import { BannerAd } from 'components/advert/advert-banner.js';
import { InterstitialPortal } from 'components/interstitial/interstitial-portal.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { AdvertSkins } from 'page/advert-skins.js';
import * as React from 'react';
import { getBannerAdData, getInterstitialData, getSkinData } from '../components/advert/utils/ad-targeting-merge.js';
import { AdDomReadyProvider } from './main-3-ads-ready-provider.js';
import { MainPageLayoutV2 } from './main-4-layout-v2.js';
import { JsonResultType } from './utils/json-page-change.js';

const MainWrapperAds = ({ pageJson }: { pageJson: JsonResultType }) => {
  const adSize = React.useContext(ScreenSizeContext);
  const interstitialData = getInterstitialData(pageJson, adSize);
  const { skinLeft, skinRight } = getSkinData(pageJson, adSize);
  const bannerConfig = getBannerAdData(pageJson, adSize);
  /** Only set boolean when we definitively know there is a banner / interstitial ad */
  const rendersBannerAd = bannerConfig ? !!bannerConfig : undefined;
  const rendersInterstitialAd = interstitialData ? !!interstitialData : undefined;

  return (
    <AdDomReadyProvider rendersBannerAd={rendersBannerAd} rendersInterstitialAd={rendersInterstitialAd}>
      <InterstitialPortal interstitialPayload={interstitialData} />
      <AdvertSkins skinLeft={skinLeft} skinRight={skinRight}>
        <MainPageLayoutV2 pageJson={pageJson}>
          <BannerAd bannerConfig={bannerConfig} />
        </MainPageLayoutV2>
      </AdvertSkins>
    </AdDomReadyProvider>
  );
};
/** We need to use this as otherwise we have additional renders take place */
export const MainWrapperAdsV2 = React.memo(MainWrapperAds);
